import { useEffect, useState } from "react";

const navLinks = [
  { label: "今日热度", id: "today" },
  { label: "爆料合集", id: "leaks" },
  { label: "大瓜盘点", id: "review" },
  { label: "吃瓜汇总", id: "feed" },
  { label: "新料速递", id: "express" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open ? "bg-background-50/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between gap-6 px-5 md:px-10 py-3.5">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span className="relative grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
            <span className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-accent-500 live-dot"></span>
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950">看料网</span>
            <span className="hidden sm:inline-block text-[11px] font-medium uppercase tracking-[0.2em] text-secondary-600">
              今日猛料 · 实时更新
            </span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* right actions */}
        <div className="flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="h-2 w-2 rounded-full bg-primary-500 live-dot"></span>
            吃瓜在线中
          </div>
          <a
            href="#express"
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
            我要投稿爆料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="grid h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-900 lg:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-3-line text-lg"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {/* mobile drawer */}
      {open && (
        <nav className="lg:hidden border-t border-background-200 bg-background-50 px-5 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#express"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-flashlight-fill" aria-hidden="true"></i>我要投稿爆料
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}